import { render, staticRenderFns } from "./VirtualdesktopForm.vue?vue&type=template&id=6d51523e&scoped=true"
import script from "./VirtualdesktopForm.vue?vue&type=script&lang=ts"
export * from "./VirtualdesktopForm.vue?vue&type=script&lang=ts"
import style0 from "./VirtualdesktopForm.vue?vue&type=style&index=0&id=6d51523e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d51523e",
  null
  
)

export default component.exports